export default __webpack_public_path__ + "static/media/icon-GNS_sm.eb30a0a6.svg";